var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCircleRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.636,
    height: 91.637,
    viewBox: "0 0 91.636 91.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-info-circle",
    transform: "translate(-1.909 -2.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M52.194,46.115V71.233h-8V46.115a4,4,0,0,1,8,0ZM48.249,25.13a6,6,0,1,0,5.956,6.043A6,6,0,0,0,48.249,25.13Zm45.3,23.008A45.818,45.818,0,1,1,47.727,2.32,45.871,45.871,0,0,1,93.545,48.138Zm-7.637,0A38.181,38.181,0,1,0,47.727,86.32,38.225,38.225,0,0,0,85.908,48.138Z",
    fill: "#E92C2C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleRed);
export default __webpack_public_path__ + "static/media/info-circle-red.90bc99214ef782be7732f463d55741d5.svg";
export { ForwardRef as ReactComponent };